<template>
  <div>
    <heading :helpInfo="sidebarCard">
      {{ $t("sidebar.personalInstructions") }}
    </heading>
    <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs"></v-breadcrumbs>
    <instructionTable />
  </div>
</template>

<script>
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";
import instructionTable from "./instructionTable.vue";
import i18n from "../../i18n";

export default {
  components: { instructionTable },
  computed: {
    sidebarCard() {
      if (this.$i18n.locale == "de") {
        return sidebarTextDE.default.instructions;
      } else if (this.$i18n.locale == "en") {
        return sidebarTextEN.default.instructions;
      }
      return sidebarTextDE.default.instructions;
    },
    breadcrumbs() {
      return [
        {
          text: i18n.t("instructions.folder.title"),
          disabled: false,
          //back to the merged page, instructions tab, not the old standalone route
          to: { path: "/app/instructionsHub", query: { tab: "instructions" } },
          exact: true,
        },
        {
          text: this.$route.params.instructionFolderName,
          disabled: true,
        },
      ];
    },
  },
  data: () => ({
    drawer: false,
  }),
};
</script>
